/**
 * Format phone number to international format: +1 (555) 123-4567
 * Handles E.164 format input (e.g., +15551234567) and US 10-digit numbers
 */
export function formatPhone(phone: string | null | undefined): string {
  if (!phone) return '';

  // Remove all non-digit characters except the leading +
  const cleaned = phone.replace(/[^\d+]/g, '');

  // Try to match with international code first
  const matchWithCode = cleaned.match(/^\+?(\d{1,3})(\d{3})(\d{3})(\d{4})$/);
  if (matchWithCode) {
    const [, countryCode, areaCode, prefix, lineNumber] = matchWithCode;
    return `+${countryCode} (${areaCode}) ${prefix}-${lineNumber}`;
  }

  // Try to match 10-digit US number without international code
  const matchUS = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (matchUS) {
    const [, areaCode, prefix, lineNumber] = matchUS;
    return `+1 (${areaCode}) ${prefix}-${lineNumber}`;
  }

  // If format doesn't match expected pattern, return original
  return phone;
}
